import { RootState } from "../store";
import { IDType } from "../config/types";

export const selectPlayerById = (playerId: IDType) => (state: RootState) =>
  state.player.players[playerId as number]?.response ?? null;

export const selectPlayerCardById = (playerId: IDType) => (state: RootState) =>
  state.player.playerCards[playerId as number]?.response ?? null;

export const selectPlayerCareerById = (playerId: IDType) => (state: RootState) =>
  state.player.playerCareers[playerId as number]?.response ?? null;

export const selectPlayerMatchesById = (playerId: IDType) => (state: RootState) =>
  state.player.playerMatches[playerId as number]?.response ?? [];

export const selectPlayerSeasonStats =
  (playerId: IDType, leagueId: IDType) => (state: RootState) => {
    const key = `${playerId}_${leagueId}`;
    return state.player.playerSeasonStats[key]?.response ?? null;
  };

export const selectPlayerStatus = (state: RootState) => state.player.status;

export const selectPlayerError = (state: RootState) => state.player.error;

export const selectIsPlayerLoaded = (playerId: IDType) => (state: RootState) =>
  !!state.player.players[playerId as number];

